import { generateVariants } from '../utils.js';
import { colors } from './colors.js';

const boxShadows = {
  default: '0 1px 3px 0 rgba(0,0,0,0.2)',
  focus: "0 0 0 2px ".concat(colors.primary.dark),
  active: '0 1px 4px 0 rgba(0,0,0,.33)',
  selected: 'inset 0 0 4px 0 rgba(0,0,0,0.2)',
  subtle: '0 1px 1px 0 rgba(0,0,0,0.1)'
};
const opacities = {
  disabled: '0.66',
  selected: '0.8'
};
const radii = generateVariants(4);
const misc = {
  boxShadows,
  opacities,
  radii
};

export { misc };
